import { Col, Flex, Row, Dropdown, Button, Space } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import React from "react";
import CustomTitle from "../components/CustomTitle";
import CustomButton from "../components/CustomButton";
import { PlusOutlined } from "@ant-design/icons";
import { useToken } from "../common/helper";

function DashboardTitle({
  title,
  showAddButton = false,
  onAddButtonClick,
  onBulkUpload,
  addButtonTitle,
  allPermissions,
}) {
  const { decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();
  const items = [
    {
      label: "Single shipment",
      key: "1",
    },
    {
      label: "Bulk upload",
      key: "2",
    },
  ];
  const handleMenuClick = (eve) => {
    if (eve.key === "1") {
      onAddButtonClick();
    } else {
      onBulkUpload();
    }
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          <Flex
            className="dashboard-title"
            wrap
            gap={16}
            justify="space-between"
            align="center"
            style={{ marginBottom: "20px" }}
          >
            <CustomTitle
              className="my-heading"
              text={title}
              fontSize="32px"
              lineHeight="40px"
              fontWeight="700"
              marginBottom={0}
            />

            {showAddButton && (
              <>
                {/* <CustomButton
                                        text={addButtonTitle}
                                        width="147px"
                                        height="36px"
                                        fontSize="14px"
                                        fontWeight="500"
                                        lineHeight="16px"
                                        borderRadius="8px"
                                        bgColor="#F3F3F3"
                                        color="#000"
                                        boxShadow="none"
                                        onClick={onAddButtonClick}
                                        iconPosition="left"
                                        gap={8}
                                        icon={<PlusOutlined color="#000" />}
                                    /> */}

                {/* {decodedToken?.role?.toLowerCase() !== "viewer" && ( */}
                  <>
                  {allPermissions?.is_create && 
                  <Dropdown
                    menu={{
                      items,
                      onClick: handleMenuClick, // Callback for menu item click
                    }}
                  >
                    <Button
                      style={{
                        padding: "6px 10px",
                        height: "30px",
                        fontSize: "10px",
                        fontWeight: "500",
                        lineHeight: "16px",
                        borderRadius: "6px",
                        border: "0",
                        backgroundColor: "#F3F3F3",
                        color: "#000",
                        boxShadow: "none",
                      }}
                    >
                      <Space>
                        <PlusOutlined
                          style={{
                            color: "#000",
                            fontSize: "10px",
                            fontWeight: "600",
                          }}
                        />
                        New Shipment
                        <DownOutlined
                          style={{ color: "#000", fontSize: "10px" }}
                        />
                      </Space>
                    </Button>

                    {/* <Button
                    
                      color="#000"
                      style={{
                        padding: "12px",
                        height: "37px",
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "20px",
                        borderRadius: "8px",
                        border: "0",
                        backgroundColor: "#F3F3F3",
                        color: "#000",
                        boxShadow: "none",
                      }}
                    >
                      <Space>
                        <PlusOutlined
                          style={{
                            color: "#000",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        />
                        New Shipment
                        <DownOutlined
                          style={{ color: "#000", fontSize: "12px" }}
                        />
                      </Space>
                    </Button> */}
                  </Dropdown>
}
                  </>
                {/* )} */}
              </>
            )}
          </Flex>
        </Col>
      </Row>
    </>
  );
}

export default DashboardTitle;
